import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { bucketItem } from './resource.service';
import { Utility, breadcrumbItem } from '../core/common';
import { SharedService } from './shared.service';
import { environment } from 'src/environments/environment';

export type RtwadStatus = 'NotPaid' | 'Pending' | 'Started' | 'Rejected' | 'Archived';
export const RtwadImagePath = '/capi/readytoworkad/image/';
export const rtwadPath = '/ready-to-work';

@Injectable({
	providedIn: 'root'
})
export class RtwadService {

	statuses: RtwadStatus[] = ['NotPaid', 'Pending', 'Started', 'Rejected', 'Archived'];

	constructor(private http: HttpClient, private sharedService: SharedService) { }

	adminSearch(criteria: RtwadSearchCriteria, from = 0, limit = 50) {
		return firstValueFrom(this.http.post<RtwadSearchResult>(environment.app.apiUrl + 'readytoworkad/admin/search', { criteria, from, limit }));
	}

	search(criteria: RtwadSearchCriteria, from = 0, limit = 10, paidCount = 0) {
		return firstValueFrom(this.http.get<RtwadSearchResult>(environment.app.apiUrl + 'readytoworkad/search', {
			params: { criteria: JSON.stringify(criteria), from, limit, paidCount }
		}));
	}

	getById(id: number) {
		return firstValueFrom(this.http.get<IrtwadModel>(environment.app.apiUrl + 'readytoworkad/' + id));
	}
	ownerGetById(id: number) {
		return firstValueFrom(this.http.get<IrtwadModel>(environment.app.apiUrl + 'readytoworkad/owner/get/' + id));
	}
	adminGetById(id: number) {
		return firstValueFrom(this.http.get<IrtwadModel>(environment.app.apiUrl + 'readytoworkad/admin/get/' + id));
	}

	getContactInfo(id: string) {
		return firstValueFrom(this.http.post<IrtwadModel>(environment.app.apiUrl + 'readytoworkad/contact-info/' + id, null));
	}

	save(model: IrtwadModel, ...images: Blob[]) {
		const body = this.addImages(images);
		body.append('rtwad', JSON.stringify(model));
		return firstValueFrom(this.http.post<IrtwadModel>(environment.app.apiUrl + 'readytoworkad/save', body));
	}

	saveAdmin(model: IrtwadModel, ...images: Blob[]) {
		const body = this.addImages(images);
		body.append('rtwad', JSON.stringify(model));
		return firstValueFrom(this.http.post<IrtwadModel>(environment.app.apiUrl + 'readytoworkad/admin/save', body));
	}

	private addImages(images: Blob[]) {
		const body = new FormData();
		for (let i = 0; i < images?.length; i++)
			body.append(`image_${i}`, images[i]);
		return body;
	}
softDelete(id: string) {
    return firstValueFrom(
        this.http.post<IrtwadModel>(`${environment.app.apiUrl}readytoworkad/${id}/soft-delete`, null)
    );
}
	getMyAds$() {
		return this.http.get<RtwadSearchResult>(environment.app.apiUrl + 'readytoworkad/my');
	}

	getSources$(): Observable<bucketItem[]> {
		return this.http.get<bucketItem[]>(environment.app.apiUrl + 'readytoworkad/sources');
	}

	getBreadcrumb(payload: { q?: string, l?: string }): breadcrumbItem[] {

		var items: breadcrumbItem[] = [{ title: 'آماده به کار', link: [rtwadPath] }];
		if (!payload) return items;

		if (payload.l) {
			const location = Utility.getLocation(payload.l);
			items.push({
				title: `استان ${location.State}`,
				link: [rtwadPath, { l: location.State }]
			});

			if (location.City)
				items.push({
					title: location.City,
					link: [rtwadPath, { l: payload.l }]
				});
		}

		if (payload.q)
			items.push({
				title: `جستجوی ${payload.q}`, link: [rtwadPath, Utility.removeEmpty({
					q: payload.q,
					l: payload.l,
				})].filter(_ => _)
			})

		return items;

	}

	setImpression(id: string) {
		return firstValueFrom(this.http.post(environment.app.apiUrl + 'readytoworkad/impression/' + id, null));
	}

	setGetContactCount(id: string) {
		return firstValueFrom(this.http.post(environment.app.apiUrl + 'readytoworkad/got-contact/' + id, null));
	}

	convertJobToReadyToWorkAd(jobId: string) {
		return firstValueFrom(this.http.get<IrtwadModel>(environment.app.apiUrl + 'readytoworkad/admin/convert-job/' + jobId));
	}


}

export interface IrtwadModel {
	Id?: string;
	Code?: number;
	Title?: string;
	Description?: string;
	Images?: string[];
	Brief?: string;
	Phone?: string;
	Email?: string;
	ContactName?: string;
	Status?: RtwadStatus;
	Tags?: string[];
	IsLtr?: boolean;
	IsRemote?: boolean;
	IsIndexed?: boolean;
	Source?: any;
	RegisterTime?: Date;
	StartTime?: Date;
	UpdateTime?: Date;
	ExpirationTime?: Date;
	UserId?: string;
	IsPaid?: boolean;
	City?: string;
	State?: string;
	GeoPoint?: string;
	Impression?: number;
	GetContactCount?: number;
}

export class RtwadSearchResult {
	List: IrtwadModel[];
	PaidList: IrtwadModel[];
	Total: number;

}

export class RtwadSearchCriteria {
	constructor(partial?: Partial<RtwadSearchCriteria>) {
		if (partial) Object.assign(this, partial);
		if (this.Source === null) this.Source = '';
	}

	Keyword?: string;
	State?: string;
	City?: string;
	Statuses?: RtwadStatus[];
	Source?: string;
	IsIndexed?: boolean;
	Sort?: string;
	IsDeleted?: boolean;
}

